export const Chh_WORDS = ['ĆUFTE', 'ĆUMUR', 'ĆELAV', 'ĆURKA', 'ĆUFTE', 'ĆEVAP', 'ĆERKA', 'ĆORAK', 'ĆOŠAK', 'ĆILIM']
